import { gql } from "@apollo/client"

export const SET_GROUP_LOG_AS_READ = gql`
  mutation setGroupLogActivityAsRead($id: ID!) {
    setGroupLogAsRead(id: $id) {
      groupLog {
        id
        read
      }
    }
  }
`
